<script src="../../../../Desktop/領澳/汇业新/main.js"></script>
<template>
  <div class="container" v-if="showAlert">
    <div class="top">
      <ul>
        <li><img src="@/assets/image/email.png"></li>
        <!--<li><img src="@/assets/image/wechat.png"></li>-->
        <li><img src="@/assets/image/fb.png"></li>
        <li class="search">
          <!-- ******************搜索框***************** -->
          <a @click="selectArticle">
            <!--<img src="@/assets/image/search.png">-->
            <span class="glyphicon glyphicon-search select-btn" style="color: #4E7DF4;"></span>
          </a>
          <input type="text" v-model="keyWord">
        </li>
        <li class="close-btn" @click="close">X</li>
      </ul>
    </div>
    <div class="content">
      <ul>
        <li @click="close">
          <router-link to="/" class="router-style" >主頁</router-link>
        </li>
        <li @click="close">
          <router-link to="/introduct" class="router-style">滙業盃簡介</router-link>
        </li>
        <li @click="close">
          <router-link to="/new-message" class="router-style">最新消息</router-link>
        </li>
        <li @click="close">
          <router-link to="/titbits" class="router-style">比賽花絮</router-link>
        </li>
        <li class="dropdown none-style"><a href="" data-toggle="dropdown" id="dropdownMenu2" class="router-style ">互動專區</a>
          <ul class="dropdown-menu" aria-labelledby="dropdownMenu1" >
            <li @click="close">
                <router-link to="/common-sense">線上常識問答比賽</router-link>
            </li>
            <!--<li @click="close">-->
              <!--<router-link to="/activity-rules">滙業盃・一人語標語創作比賽</router-link>-->
            <!--</li>-->
            <!--<li @click="close">-->
              <!--<router-link to="/activity-rules">滙業盃・成長微電影創作比賽</router-link>-->
            <!--</li>-->
            <li  @click="close" v-for="(activity) in activitys" :key="activity.id">
              <div class="titibs-menu">
                <router-link :to="{path: 'activity-rules', query: {id:activity.id}}">{{activity.name}}</router-link></div>
            </li>
          </ul>
        </li>
        <li @click="close">
          <router-link to="/enrolls" class="router-style">滙業盃專區</router-link>
        </li>
        <li @click="close">
          <router-link to="/news" class="router-style">傳媒中心</router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'indexNav',
  data () {
    return {
      showAlert: false,
      activitys: [],
      keyWord: ''
    }
  },
  methods: {
    show: function () {
      this.showAlert = true
    },
    close: function () {
      this.showAlert = false
    },
    // 获取所有的活动
    getAllActivity: function () {
      var that = this
      this.$axios.get('/activity/name')
        .then(function (response) {
          that.activitys = response.data.data
          // console.log(that.activitys)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    selectArticle: function () {
      var that = this
      this.$router.push({name: 'new-message', query: {kw: that.keyWord}})
      this.$router.go(0)
    }
  },
  mounted () {
    this.getAllActivity()
  }
}
</script>

<style scoped>
  .container{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 5;
    background-image: linear-gradient(-135deg, #6C47D3 0%, #4290FF 100%);
  }
  .top{
    margin-top: 20px;

    border-bottom: solid #D8D8D8;
  }
  .top ul {
    margin: 0px;
    margin-bottom: 15px;
    padding: 0px;
    text-align: center;
  }
  .top ul li{
    display: inline;
    margin-right: 10px;
  }
  .top .search{
    margin-left: -25px;
  }
  .top .search input{
    width: 140px;
  }
  .top .close-btn{
    float: right;
    /*margin-left: 20px;*/
    color: #ffffff;
    font-size: 18px;
  }
  .content ul{
    margin: 0px;
    padding: 0px;
    text-align: center;

  }
  .content ul li{
    margin-top: 15px;
    list-style-type: none;
    text-decoration: none;
  }
  .content ul li:active{
    border-radius: 15px;
    background: #fff;

  }
  .content ul li a{
    font-size: 18px;
    color: #FFFFFF;
  }
  .content ul li a:active{
    text-decoration: none;
    color: #000000;
  }
  .content .dropdown button{
    background: rgba(0,0,0,0);
    border: none;
    color: #ffffff;
  }

  .content .dropdown-menu{
    position: relative;
    width: 80%;
    margin-left: 10%;
    margin-right: 10%;
    border-radius: 20px;
  }

  .content .dropdown-menu .titibs-menu{
    width: 80%;
    margin-left: 10%;
    margin-bottom: 10px;
  }
  /*.none-style li:active{*/
    /*color: #fff;*/
    /*border-radius: 0px;*/
    /*background: #000;*/
  /*}*/
  .content .dropdown-menu li a{
    color: #000;
    word-break: normal;
  }
  .content .dropdown-menu li a:active{
    background: #617BE4;
  }
  .content .dropdown-menu li div:active{
    background: #617BE4;
  }
</style>



// WEBPACK FOOTER //
// src/components/indexNav.vue